import React, {useContext} from 'react';
import styled from 'styled-components';

import Picture from '@/components/Picture';
import MobileLogo from '@/assets/svg/Header/Logo/BelMebel.mobile.logo.svg';
import {LogoContext} from '@/providers/LogoTriggerProvider/LogoTriggerProvider';
import {getCurrentProject} from "@/utils/common";

import dveriLogo from './assets/dveri_logo.webp';

function Logo() {
  const {triggerLogo} = useContext(LogoContext);
  const project = getCurrentProject();

  if (project === 'dveri') {
    return <DveriImage onClick={() => triggerLogo?.(true)}>
      <img src={dveriLogo}/>
    </DveriImage>
  }

  return (
    <Component onClick={() => triggerLogo?.(true)}>
      <Picture src={MobileLogo}/>
    </Component>
  );
}

const Component = styled.div`
  img {
    cursor: pointer;
    height: 20.97px;
  }
`;

const DveriImage = styled.div`
  img {
    height: 30px;
  }
`;

export default Logo;
